import { GHOST_PREVIEW_OPACITY } from "@/features/LiveFormEditor/LivePreview/ghostPreview.constant";
import { useIsGhostPreview } from "@/features/LiveFormEditor/LivePreview/useIsGhostPreview";
import { FormDivider } from "@/forms-design-system/FormDivider";

export const DonationFormDivider = () => {
  const dividerIsGhostPreview = useIsGhostPreview("Amounts");

  return <FormDivider sx={{ opacity: dividerIsGhostPreview ? GHOST_PREVIEW_OPACITY : 1 }} />;
};
